<template>
  <div class="spinner">
    <img src="../assets/loading.svg" alt="loading"/>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'auth-callback',
  mounted() {
    const {
      // eslint-disable-next-line
      code, state, oauth_token, oauth_verifier,
    } = this.$route.query;
    const { connection } = this.$route.params;
    this.handleAuthentication({
      connection,
      code,
      oauth_token,
      oauth_verifier,
      encodedState: state,
    });
  },
  methods: mapActions('auth', ['handleAuthentication']),
};
</script>

<style>
  .spinner {
    position: absolute;
    display: flex;
    justify-content: center;
    height: 100vh;
    width: 100vw;
    background-color: white;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
</style>
